export default "__VITE_ASSET__CrFU8pig__"